import { IReqCandidatesContactDetails } from 'modules/hiring/models/IRequisitionCandidates.interface';
import { IObjectData } from '../candidateApplication/candidateApplicationDetails.helper';
import { mapDataToLabelAndValue } from 'modules/hiring/utilities';
import { ICandidateProfileApplicationHistory } from 'modules/hiring/models/candidateProfile.model';
import { dateFormatWithLeadingZeroForMonth } from 'utilities/formatDate';
import {
  HMDecisionModalActions,
  getMakeDecisionStage,
  getMakeDecisionStatus,
} from 'modules/hiring/models/hiringDecisionOption';
import { IHiringMakeDecision } from './makeDecisionModal';
import { t } from 'i18next';

export const mapCandidateContactDetailsData = (
  contact?: IReqCandidatesContactDetails
) => {
  const data: IObjectData = {
    contact: {
      location: contact?.location,
      telephone: contact?.phone,
      eMail: contact?.email,
      numberofApplicationsInProgress: contact?.numberofApplicationsInProgress,
    },
  };
  return mapDataToLabelAndValue(data);
};

export const mapCandidateAppliedForData = (
  appliedFor?: ICandidateProfileApplicationHistory
) => {
  const data: IObjectData = {
    appliedFor: {
      jobTitle: `${appliedFor?.jobTitle} (${appliedFor?.requisitionID})`,
      applicationStage: appliedFor?.applicationStage,
      jobLocation: appliedFor?.jobLocation,
      dateApplied: appliedFor?.applicationDate
        ? dateFormatWithLeadingZeroForMonth(appliedFor?.applicationDate ?? '')
        : t('notAvailable').toString(),
    },
  };
  return mapDataToLabelAndValue(data);
};

export const mapDataForDecision = (
  selectedApplication: ICandidateProfileApplicationHistory,
  note: string,
  activeDecision: HMDecisionModalActions,
  hiringManagerName: string
) => {
  const payload: IHiringMakeDecision = {
    org_id: selectedApplication?.organizationId,
    requisition_id: +selectedApplication?.requisitionID,
    candidate_Details: [
      {
        candidate_id: selectedApplication?.candidateId,
        application_id: selectedApplication?.applicationID,
      },
    ],
    activity_stage: selectedApplication?.applicationStage,
    current_Activity: null,
    application_status: selectedApplication?.activityStatus,
    comments: note,
    updated_by: hiringManagerName,
    current_activity_status: getMakeDecisionStatus(activeDecision),
  };
  return payload;
};
